if (!customElements.get('subscription-purchase-options')) {
  customElements.define(
    'subscription-purchase-options',
    class SubscriptionPurchaseOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.variantInput = this.querySelector('.product-variant-id');
        this.sellingPlanInput = this.querySelector('[data-subscription-selling-plan]');
        this.quantityInput = this.querySelector('[data-purchase-quantity]');
        this.actions = this.querySelector('[data-purchase-actions]');
        this.subscriptionActions = this.querySelector('[data-subscription-actions]');
        this.onetimeActions = this.querySelector('[data-onetime-actions]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.buttonLabel = this.querySelector('[data-add-to-cart-label]');
        this.planList = this.querySelector('[data-selling-plan-list]');

        const dataNode = this.querySelector('[data-subscription-variants]');
        this.variants = dataNode ? JSON.parse(dataNode.textContent) : {};

        this.querySelectorAll('[data-purchase-option]').forEach((radio) => {
          radio.addEventListener('change', () => this.setPurchaseOption(radio.value));
        });

        this.variantChangeHandler = (event) => {
          if (this.contains(event.target)) return;

          [0, 250, 750, 1500].forEach((delay) => {
            window.setTimeout(() => {
              if (this.isConnected) this.syncVariant();
            }, delay);
          });
        };

        const productInfo = this.closest('product-info');
        if (productInfo) {
          productInfo.addEventListener('change', this.variantChangeHandler);
        }

        this.syncVariant();
        this.setPurchaseOption('subscription');
      }

      disconnectedCallback() {
        const productInfo = this.closest('product-info');

        if (productInfo && this.variantChangeHandler) {
          productInfo.removeEventListener('change', this.variantChangeHandler);
        }
      }

      get activeOption() {
        return (
          this.querySelector('[data-purchase-option]:checked')?.value ||
          'subscription'
        );
      }

      setPurchaseOption(option) {
        const isSubscription = option === 'subscription';

        this.querySelectorAll('[data-purchase-card]').forEach((card) => {
          const selected = card.dataset.purchaseCard === option;

          card.classList.toggle('is-selected', selected);

          const details = card.querySelector('[data-purchase-details]');
          if (details) details.hidden = !selected;
        });

        if (isSubscription) {
          this.quantityInput.value = 1;
          this.quantityInput.setAttribute('value', '1');
          this.sellingPlanInput.disabled = false;

          if (this.actions) {
            this.subscriptionActions.appendChild(this.actions);
          }
        } else {
          this.sellingPlanInput.value = '';
          this.sellingPlanInput.disabled = true;
          this.restoreOneTimeMinimum();

          if (this.actions) {
            this.onetimeActions.appendChild(this.actions);
          }
        }
      }

      restoreOneTimeMinimum() {
        const config = this.variants[this.variantInput.value];
        const minimum = config?.minimum || 1;

        if (Number(this.quantityInput.value) < minimum) {
          this.quantityInput.value = minimum;
        }
      }

      syncVariant() {
        const variantId = this.variantInput?.value;
        const config = this.variants[variantId];

        if (!config) return;

        this.querySelector('[data-onetime-price]').textContent = config.price;

        this.quantityInput.min = config.minimum || 1;
        this.quantityInput.dataset.min = config.minimum || 1;
        this.quantityInput.step = config.increment || 1;

        if (config.maximum) {
          this.quantityInput.max = config.maximum;
          this.quantityInput.dataset.max = config.maximum;
        } else {
          this.quantityInput.removeAttribute('max');
          delete this.quantityInput.dataset.max;
        }

        this.submitButton.disabled = !config.available;
        this.buttonLabel.textContent = config.available
          ? 'Add to cart'
          : 'Sold out';

        this.renderPlans(config.plans || []);
        this.setPurchaseOption(this.activeOption);
      }

      renderPlans(plans) {
        this.planList.replaceChildren();

        if (!plans.length) {
          const subscriptionRadio = this.querySelector(
            '[data-purchase-option][value="subscription"]'
          );
          const oneTimeRadio = this.querySelector(
            '[data-purchase-option][value="onetime"]'
          );

          subscriptionRadio.disabled = true;
          oneTimeRadio.checked = true;
          this.setPurchaseOption('onetime');
          return;
        }

        this.querySelector(
          '[data-purchase-option][value="subscription"]'
        ).disabled = false;

        plans.forEach((plan, index) => {
          const label = document.createElement('label');
          label.className = 'subscription-purchase__plan';

          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = `selling_plan_choice_${this.dataset.sectionId}`;
          radio.value = plan.id;
          radio.checked = index === 0;

          radio.addEventListener('change', () => {
            this.sellingPlanInput.value = plan.id;
            this.updateSubscriptionPrice(plan);
          });

          const interval = document.createElement('span');
          interval.className = 'subscription-purchase__plan-name';
          interval.textContent = this.friendlyPlanName(plan.name);

          const discount = document.createElement('span');
          discount.className = 'subscription-purchase__plan-discount';
          discount.textContent = `save ${plan.savings}%`;

          label.append(radio, interval, discount);
          this.planList.appendChild(label);
        });

        this.sellingPlanInput.value = plans[0].id;
        this.updateSubscriptionPrice(plans[0]);
      }

      updateSubscriptionPrice(plan) {
        this.querySelector(
          '[data-subscription-original-price]'
        ).textContent = plan.originalPrice;

        this.querySelector('[data-subscription-price]').textContent =
          plan.price;

        this.querySelector('[data-subscription-savings]').textContent =
          plan.savings;

        this.querySelector(
          '[data-subscription-badge]'
        ).textContent = `Save ${plan.savings}%`;
      }

      friendlyPlanName(name) {
        const match = name.match(
          /(\d+)\s+(day|week|month|year)s?/i
        );

        if (!match) return name;

        return `${match[1]} ${match[2].toLowerCase()}${
          Number(match[1]) === 1 ? '' : 's'
        }`;
      }
    }
  );
}